import { render, staticRenderFns } from "./CaptchaBox.vue?vue&type=template&id=5d9db462&scoped=true&"
import script from "./CaptchaBox.vue?vue&type=script&lang=js&"
export * from "./CaptchaBox.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaBox.vue?vue&type=style&index=0&id=5d9db462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9db462",
  null
  
)

export default component.exports